import { createFeatureSelector, createSelector } from '@ngrx/store';

import { TermsConditionsState } from './terms-conditions.state';

/**
 * Definición del selector
 */
export const selectTermsConditionsState = createFeatureSelector<TermsConditionsState>('terms-conditions');

export const isDSCAcceptanceRequired = createSelector(
    selectTermsConditionsState,
    (state: TermsConditionsState) => state.districtSaleContractAcceptanceRequired
);

export const isCheckAllTermsAndConditions = createSelector(
    selectTermsConditionsState,
    (state: TermsConditionsState) => state.checkAllTermsAndConditions
);
